import { escapeHTML } from "./ui-helpers.js";

export function renderActivityTimeline(entries, opts = {}) {
  if (!entries || entries.length === 0) return "";
  const live = opts.live || false;
  const limit = opts.limit || 0;

  let tier1 = entries.filter((e) => e.tier === 1);
  let tier2 = entries.filter((e) => e.tier === 2);

  if (limit > 0) {
    // Show all tier-1 (capped), and latest N tier-2
    if (tier1.length > limit) tier1 = tier1.slice(-limit);
    tier2 = tier2.slice(-2);
  }

  // Interleave back in original order
  const visible = entries.filter((e) => tier1.includes(e) || tier2.includes(e));

  const referenceTimestamp = entries[0]?.timestamp || null;

  const nodes = visible
    .map((entry, idx) => {
      const isLast = idx === visible.length - 1;
      if (entry.tier === 1) {
        return renderTimelineNode(entry, { pulse: live && isLast, referenceTimestamp });
      }
      return renderTimelineStep(entry);
    })
    .join("");

  return `<div class="activity-timeline"><div class="activity-timeline__spine">${nodes}</div></div>`;
}

export function renderTimelineNode(entry, opts = {}) {
  const pulse = opts.pulse ? " timeline-node__dot--pulse" : "";
  const toneClass = entry.tone ? ` timeline-node--${escapeHTML(entry.tone)}` : "";
  const timeLabel =
    opts.referenceTimestamp && entry.timestamp
      ? formatRelativeTime(entry.timestamp, opts.referenceTimestamp)
      : "";
  return `<div class="timeline-node${toneClass}"><span class="timeline-node__dot${pulse}"></span><span class="timeline-node__label">${escapeHTML(entry.title || "")}</span>${timeLabel ? `<span class="timeline-node__time">${escapeHTML(timeLabel)}</span>` : ""}</div>`;
}

export function renderTimelineStep(entry) {
  return `<div class="timeline-step">${escapeHTML(entry.title || entry.detail || "")}</div>`;
}

export function renderCompactActivitySummary(summary, opts = {}) {
  const parts = [];
  if (summary.toolCount > 0)
    parts.push(`${summary.toolCount} tool call${summary.toolCount === 1 ? "" : "s"}`);
  if (summary.decisionCount > 0)
    parts.push(`${summary.decisionCount} decision${summary.decisionCount === 1 ? "" : "s"}`);
  if (summary.stepCount > 0 && summary.stepCount !== summary.toolCount)
    parts.push(`${summary.stepCount} step${summary.stepCount === 1 ? "" : "s"}`);
  if (summary.durationMs > 0) {
    const seconds = Math.floor(summary.durationMs / 1000);
    parts.push(`in ${seconds}s`);
  }
  if (parts.length === 0) return "";
  return `<div class="activity-summary">${escapeHTML(parts.join(", "))}</div>`;
}

function formatRelativeTime(timestamp, referenceTimestamp) {
  if (!timestamp || !referenceTimestamp) return "";
  const ms = new Date(timestamp).getTime() - new Date(referenceTimestamp).getTime();
  if (Number.isNaN(ms) || ms < 0) return "";
  const totalSeconds = Math.floor(ms / 1000);
  if (totalSeconds >= 300) return "5m+";
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes > 0)
    return `${minutes}m${seconds > 0 ? String(seconds).padStart(2, "0") + "s" : ""}`;
  return `${seconds}s`;
}
